export function registerServiceWorker(): void {
  clearAppBadge();

  window.addEventListener('focus', clearAppBadge);
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') clearAppBadge();
  });

  if (!('serviceWorker' in navigator)) return;

  window.addEventListener('load', () => {
    clearAppBadge();
    navigator.serviceWorker.register('/sw.js').catch((err) => {
      console.error('service worker registration failed:', err);
    });
  });
}

function clearAppBadge(): void {
  const nav = navigator as Navigator & { clearAppBadge?: () => Promise<void> };
  if (!nav.clearAppBadge) return;

  void nav.clearAppBadge().catch(() => {});
}
